import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center gap-1 whitespace-nowrap rounded-pill border px-2.5 py-[3px] text-[10.5px] font-medium tracking-[0.6px] transition-colors focus:outline-none focus-visible:shadow-fc-focus",
  {
    variants: {
      variant: {
        default: "border-fc-accent/40 bg-fc-accent/[0.14] text-fc-accent-bright",
        secondary: "border-fc-stroke-2 bg-white/[0.06] text-fc-txt2",
        destructive: "border-fc-red/35 bg-fc-red/[0.12] text-fc-red-soft",
        warning: "border-fc-yellow/35 bg-fc-yellow/[0.12] text-fc-yellow",
        success: "border-fc-green/35 bg-fc-green/[0.12] text-fc-green",
        outline: "border-fc-stroke-2 bg-transparent text-fc-txt2",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
